import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export type SetKeyboardEnabledCommandParams = {
  enabled: 0 | 1
};

export class SetKeyboardEnabledCommand extends JsToClientCommand<SetKeyboardEnabledCommandParams> {
    constructor(params: SetKeyboardEnabledCommandParams) {
        super(ClientCommands.SET_KEYBOARD_ENABLED, params);
    }
}
